export default "__VITE_ASSET__f791e767__"